/* import __COLOCATED_TEMPLATE__ from './suggestion-customer-queries-item.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import { type PulseAccordionSection } from 'glint/pulse';
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    section: PulseAccordionSection;
    sectionId: string;
    queries: string[];
  };
}

const SuggestionCustomerQueriesItem = templateOnlyComponent<Signature>();
export default SuggestionCustomerQueriesItem;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::OptimizeSuggestions::Suggestions::SuggestionAccordionItems::SuggestionCustomerQueriesItem': typeof SuggestionCustomerQueriesItem;
    'reporting/automation/ai-insights/optimize-suggestions/suggestions/suggestion-accordion-items/suggestion-customer-queries-item': typeof SuggestionCustomerQueriesItem;
  }
}
